import React from 'react'
import { IoMdCloseCircleOutline } from "react-icons/io";


function Modal({ contrast, title, active, setActive, children }) {

    return (
        active && (
            <div onClick={() => setActive(false)} className='modal-overlay !p-0 !backdrop-blur-sm !bg-transparent'>
                <div onClick={(e) => e.stopPropagation()} className='edit-captacao-modal !text-black !w-auto !relative !min-w-[40%] !max-w-[50%] text-xl !p-0 !shadow-lg'>
                    <section className={`absolute !text-${contrast} right-0 !p-0 !m-0 transition-none top-0 !mr-3 !mt-4 cursor-pointer hover:opacity-70`} onClick={() => setActive(false)}>
                        <IoMdCloseCircleOutline fontSize={24} />
                    </section>
                    {children}
                </div>
            </div>
        )
    )
}

export default Modal